import {
	faAmazon,
	faApple,
	faAudible,
	faGoodreads,
	faGooglePlay
} from "@fortawesome/free-brands-svg-icons";
import { faBook, faBookReader } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useRef } from "react";
import { VideoGallery } from "../components";
import { JSONVid } from "../utils/interfaces";

const REVIEW_VIDEOS = [
	{
		title: "BREACH OF PEACE -REVIEW",
		id: "TaIOWIhG9gw",
		link: "https://www.youtube.com/watch?v=TaIOWIhG9gw",
		author: "Daniel Greene",
		// channelUrl: "https://www.youtube.com/channel/UCw--xPGVVxYzRsWyV1nFqgg",
		desc: "My review of Daniel Greene's Breach of Peace!"
	},
	{
		title: "BREACH OF PEACE - Pre-Order/Release Date/Unboxing!",
		id: "rHx-SYR4_Es",
		link: "https://www.youtube.com/watch?v=rHx-SYR4_Es",
		author: "Daniel Greene",
		// channelUrl: "https://www.youtube.com/channel/UCw--xPGVVxYzRsWyV1nFqgg",
		desc: ""
	},
	{
		title: "BREACH OF PEACE CELEBRATION LIVE STREAM!",
		id: "qii38GLEtq8",
		link: "https://www.youtube.com/watch?v=qii38GLEtq8",
		author: "Daniel Greene",
		// channelUrl: "https://www.youtube.com/channel/UCw--xPGVVxYzRsWyV1nFqgg",
		desc: ""
	},
	{
		title: "Reviewing Daniel Greene's Novella! Breach of Peace!",
		id: "NHYwmLVaiSg",
		link: "https://www.youtube.com/watch?v=NHYwmLVaiSg",
		author: "Merphy Napier",
		// channelUrl: "https://www.youtube.com/channel/UC7FW6FYqPLeQIXMSulBfOLw",
		desc: ""
	},
	{
		title: "Breach of Peace by Daniel Greene | Spoiler-Free Review",
		id: "XRledNAT94Y",
		link: "https://www.youtube.com/watch?v=XRledNAT94Y",
		author: "Captured in Words",
		// channelUrl: "https://www.youtube.com/channel/UCsKrxPsbhqYwzzAN7bv35Eg",
		desc:
			"Here is my spoiler-free review for Breach of Peace by Daniel Greene! This 140 page novella (releasing March 30th) is the first in what is planned to be a trilogy of novellas leading up to a full series of novels."
	},
	{
		title:
			"Daniel Greene Discusses His New Book, BREACH OF PEACE (and much more)",
		id: "MZef1jIQ_VQ",
		link: "https://www.youtube.com/watch?v=MZef1jIQ_VQ",
		author: "Man Carrying Thing",
		// channelUrl: "https://www.youtube.com/channel/UCPdaxSov0mgwh77JvjQO2jQ",
		desc:
			"Folks, we got an interview with the goblin lord himself, Daniel Greene. We discussed his new novella, Breach of Peace, writing craft, and Youtube tips. I was INSANELY excited to talk with the person who inspired me to start my own youtube channel. I hope you all enjoy!"
	},

	{
		title: "A GOOD YouTuber book? - Breach of Peace review",
		id: "MP3uJ_cMYZU",
		link: "https://www.youtube.com/watch?v=MP3uJ_cMYZU",
		author: "James Tullos",
		// channelUrl: "https://www.youtube.com/channel/UCfOPL5nYErWwZ_feQavvqeA",
		desc: ""
	}
];

const BooksPage = () => {
	const [purchasePanel, setPurchasePanel] = useState(false);
	const panelRef = useRef(null);
	useOutsideAlerter(panelRef);

	function useOutsideAlerter(ref) {
		useEffect(() => {
			const handleClickOutside = e => {
				if (ref.current && !ref.current.contains(e.target))
					setPurchasePanel(false);
			};
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}

	return (
		<div>
			{/* book hero  */}
			<section className="grid grid-cols-1 gap-0 bg-gray-50 bg-opacity-25 md:grid-cols-2">
				<div className="flex flex-col items-start justify-center px-4 pb-24 pt-12 lg:px-20">
					{/* <span className="mb-3 text-white bg-greene badge">
						By Daniel Greene
					</span> */}
					<h1 className="mb-6 congress text-4xl font-bold leading-tight md:text-4xl lg:text-5xl">
						Breach of Peace
					</h1>
					<p className="pr-0 mb-4 text-lg tracking-relaxed lg:pr-16">
						When an imperial family is found butchered, Officers of God are
						called to investigate. Evidence points to a rebel group trying to
						stab fear into the very heart of the empire. Inspector Khlid begins
						a harrowing hunt for those responsible, but when a larger conspiracy
						comes to light, she struggles to trust even the officers around her.
						Read Daniel Greene's bestselling debut novella today!
					</p>
					<div className="inline mt-4" ref={panelRef}>
						<div className="relative inline-block text-left">
							<div>
								<button
									type="button"
									onClick={() => setPurchasePanel(!purchasePanel)}
									className="text-left items-center justify-center w-full text-white font-semibold mb-2 bg-greene-light hover:bg-greene px-4 py-2 rounded-lg btn btn-light btn-lg sm:w-auto sm:mb-0 inline-flex mr-2 transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105 p focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
									id="menu-button"
									aria-expanded="true"
									aria-haspopup="true"
								>
									Purchase Today
									<svg
										className="-mr-1 ml-2 h-5 w-5"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										aria-hidden="true"
									>
										<path
											fillRule="evenodd"
											d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
											clipRule="evenodd"
										/>
									</svg>
								</button>
							</div>

							{purchasePanel && (
								<div
									className="origin-top-right absolute  mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
									role="menu"
									aria-orientation="vertical"
									aria-labelledby="menu-button"
								>
									<div className="py-1" role="none">
										<a
											href="https://www.amazon.com/Breach-Peace-Daniel-B-Greene/dp/0578840774"
											className="text-gray-700 block px-4 py-2 text-sm"
											role="menuitem"
											id="menu-item-0"
										>
											<FontAwesomeIcon icon={faAmazon} className="mr-2" />
											Amazon
										</a>
									</div>
									<div className="py-1" role="none">
										<a
											href="https://www.audible.com/pd/Breach-of-Peace-Audiobook/B08Z8L7D5Q?source_code=AUDFPWS0223189MWT-BK-ACX0-245468&ref=acx_bty_BK_ACX0_245468_rh_us"
											className="text-gray-700 block px-4 py-2 text-sm"
											role="menuitem"
											id="menu-item-0"
										>
											<FontAwesomeIcon icon={faAudible} className="mr-2" />
											Audible
										</a>
									</div>
									<div className="py-1" role="none">
										<a
											href="https://www.bookdepository.com/Breach-Peace-Daniel-B-Greene/9780578840772?ref=grid-view&qid=1614780912232&sr=1-1"
											className="text-gray-700 block px-4 py-2 text-sm"
											role="menuitem"
											id="menu-item-0"
										>
											<FontAwesomeIcon icon={faBook} className="mr-2" />
											Barnes & Noble
										</a>
									</div>
									<div className="py-1" role="none">
										<a
											href="https://play.google.com/store/books/details/Daniel_B_Greene_BREACH_OF_PEACE?id=xJIbEAAAQBAJ"
											className="text-gray-700 block px-4 py-2 text-sm"
											role="menuitem"
											id="menu-item-0"
										>
											<FontAwesomeIcon icon={faGooglePlay} className="mr-2" />
											Google Books
										</a>
									</div>
									<div className="py-1" role="none">
										<a
											href="https://books.apple.com/us/book/breach-of-peace/id1553107871"
											className="text-gray-700 block px-4 py-2 text-sm"
											role="menuitem"
											id="menu-item-0"
										>
											<FontAwesomeIcon icon={faApple} className="mr-2" />
											Apple Books
										</a>
									</div>
									<div className="py-1" role="none">
										<a
											href="https://www.bookdepository.com/Breach-Peace-Daniel-B-Greene/9780578840772?ref=grid-view&qid=1614780912232&sr=1-1"
											className="text-gray-700 block px-4 py-2 text-sm"
											role="menuitem"
											id="menu-item-0"
										>
											<FontAwesomeIcon icon={faBookReader} className="mr-2" />
											Kobo
										</a>
									</div>
									<div className="py-1" role="none">
										<a
											href="https://www.bookdepository.com/Breach-Peace-Daniel-B-Greene/9780578840772?ref=grid-view&qid=1614780912232&sr=1-1"
											className="text-gray-700 block px-4 py-2 text-sm"
											role="menuitem"
											id="menu-item-0"
										>
											<FontAwesomeIcon icon={faBook} className="mr-2" />
											Book Depository
										</a>
									</div>
								</div>
							)}
						</div>
						{/* <a
							className="items-center justify-center w-full text-white font-semibold mb-2 bg-greene-light hover:bg-greene px-4 py-2 rounded-lg btn btn-light btn-lg sm:w-auto sm:mb-0 inline mr-2 transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105 p"
							href="https://www.amazon.com/Breach-Peace-Daniel-B-Greene/dp/0578840774"
						>
							Get on Amazon
							<FontAwesomeIcon icon={faAmazon} className="ml-2" />
						</a> */}
						<a
							className={`items-center justify-center w-full text-white font-semibold mb-2 bg-greene-light hover:bg-greene px-4 py-2 rounded-lg btn btn-light btn-lg sm:w-auto sm:mb-0 block mt-2 lg:inline transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105 ${
								purchasePanel ? "invisible lg:visible" : ""
							}`}
							href="https://www.goodreads.com/book/show/56663640-breach-of-peace"
						>
							View on GoodReads
							<FontAwesomeIcon icon={faGoodreads} className="ml-2 inline" />
						</a>
					</div>
				</div>
				<div>
					<img
						src="https://user-images.githubusercontent.com/47064842/115319624-3abe4080-a14e-11eb-9762-5b41ee5bea30.jpg"
						alt="Breach Cover"
						className="object-cover w-full h-full bg-gray-100 md:max-h-screen object-left-top"
						loading="lazy"
					/>
				</div>
			</section>

			{/* testimonials  */}
			<section className="px-4 py-24 mx-auto max-w-7xl">
				<div className="w-9/10 mx-auto text-center md:w-5/6 lg:w-4/5">
					<h1 className="mb-6 text-xl font-semibold text-gray-700 md:leading-tight md:text-2xl">
						“Existing in a world that feels like its been clawed from the
						cruelest corners of Abercrombie's FIRST LAW series, Greene's novella
						blends fantasy, mystery, and horror in a stunningly unique fusion of
						the works of Arthur Conan Doyle and Stephen King. From page one,
						we're pulled into the book's universe by the puzzle of a gruesome
						whodunit, and though the crime is overseen by a cast of
						compellingly-competent characters, genius is little match for the
						speed and force of what's coming. Indeed, the book's propulsive pace
						careens onward until it slams us up against a finish as powerful as
						the action and catharsis from ALIEN's final showdown. And, at a time
						when even the best fiction struggles to outrun the madness of
						reality,{" "}
						<span className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-greene-light to-blue-500">
							BREACH OF PEACE
						</span>{" "}
						is everything I could ever want from a novella and more!”
					</h1>
					<div className="mx-auto mb-3 ">
						<p className="text-lg sm:text-xl  congress font-bold text-greene inline mr-2">
							— Evan Winter{" "}
						</p>
						<img
							src="https://user-images.githubusercontent.com/47064842/115319003-e1a1dd00-a14c-11eb-818d-88d9ac95fef0.png"
							alt="Evan Winter Portrait"
							className="h-8 w-8 rounded-2xl shadow-lg avatar inline"
						/>
					</div>
				</div>
			</section>

			{/* review gallery */}
			<section className=" mx-auto px-4 max-w-7xl lg:max-w-9xl">
				<h2 className="mb-2 text-3xl congress font-extrabold leading-tight text-gray-900">
					Info, Reviews, & Interviews
				</h2>
				<p className="mb-6 text-lg text-gray-500">
					A collection of "Breach of Peace"-related content
				</p>
			</section>
			<VideoGallery videos={REVIEW_VIDEOS as JSONVid[]} />
		</div>
	);
};
export default BooksPage;
